exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table > tbody tr.highlight,\ntable > thead table > tfoot tr.highlight {\n  background-color: #b3d9ea !important;\n}\ntable > tbody tr.highlight > td,\ntable > thead table > tfoot tr.highlight > td,\ntable > tbody tr.highlight > th,\ntable > thead table > tfoot tr.highlight > th {\n  background-color: #b3d9ea !important;\n}\n", ""]);

// exports
